import {
  filterOptionsWithWindow,
  LIST_WINDOW_SIZE,
  matchesNumericField,
  matchesTextByWordStart,
  MIN_TEXT_QUERY_LENGTH,
  normalizeText,
  scoreTextByWordStart,
} from '../selectSearchFilter';

export { LIST_WINDOW_SIZE, MIN_TEXT_QUERY_LENGTH, normalizeText };

export function matchesUsuarioQuery(usuario, query) {
  if (matchesTextByWordStart(usuario.nome, query)) {
    return true;
  }

  return matchesNumericField(usuario.matricula, query);
}

export function scoreUsuarioMatch(usuario, query) {
  const textScore = scoreTextByWordStart(usuario.nome, query);
  if (textScore) {
    return textScore;
  }

  if (matchesNumericField(usuario.matricula, query)) {
    return 1;
  }

  return 0;
}

export function filterUsuarioOptions(
  options,
  { inputValue },
  { windowSize = LIST_WINDOW_SIZE, loadedCount } = {}
) {
  return filterOptionsWithWindow(options, inputValue, {
    windowSize,
    loadedCount,
    matchFn: (usuario, q) => matchesUsuarioQuery(usuario, q),
    sortFn: (a, b, q) => {
      const scoreDiff = scoreUsuarioMatch(b, q) - scoreUsuarioMatch(a, q);
      if (scoreDiff !== 0) {
        return scoreDiff;
      }
      return normalizeText(a.nome).localeCompare(normalizeText(b.nome), 'pt-BR');
    },
  });
}
